/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/giftcard/service.proto" (package "rd.api.giftcard", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { GiftCardService } from "./service_pb";
import type { EnableOrDisableGiftCardsRes } from "./service_pb";
import type { EnableOrDisableGiftCardsReq } from "./service_pb";
import type { SellGiftCardAtDifferentPriceRes } from "./service_pb";
import type { SellGiftCardAtDifferentPriceReq } from "./service_pb";
import type { GetGiftCardHistoryPDFRes } from "./service_pb";
import type { GetGiftCardHistoryPDFReq } from "./service_pb";
import type { DeactivateGiftCardRes } from "./service_pb";
import type { DeactivateGiftCardReq } from "./service_pb";
import type { BulkImportGiftCardNumbersRes } from "./service_pb";
import type { BulkImportGiftCardNumbersReq } from "./service_pb";
import type { BulkGenerateGiftCardNumbersRes } from "./service_pb";
import type { BulkGenerateGiftCardNumbersReq } from "./service_pb";
import type { ListGiftCardHistoryRes } from "./service_pb";
import type { ListGiftCardHistoryReq } from "./service_pb";
import type { GetGiftCardByNumberRes } from "./service_pb";
import type { GetGiftCardByNumberReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetGiftCardRes } from "./service_pb";
import type { GetGiftCardReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.giftcard.GiftCardService
 */
export interface IGiftCardServiceClient {
    /**
     * @generated from protobuf rpc: GetGiftCard
     */
    getGiftCard(input: GetGiftCardReq, options?: RpcOptions): UnaryCall<GetGiftCardReq, GetGiftCardRes>;
    /**
     * @generated from protobuf rpc: GetGiftCardByNumber
     */
    getGiftCardByNumber(input: GetGiftCardByNumberReq, options?: RpcOptions): UnaryCall<GetGiftCardByNumberReq, GetGiftCardByNumberRes>;
    /**
     * @generated from protobuf rpc: ListGiftCardHistory
     */
    listGiftCardHistory(input: ListGiftCardHistoryReq, options?: RpcOptions): UnaryCall<ListGiftCardHistoryReq, ListGiftCardHistoryRes>;
    /**
     * @generated from protobuf rpc: BulkGenerateGiftCardNumbers
     */
    bulkGenerateGiftCardNumbers(input: BulkGenerateGiftCardNumbersReq, options?: RpcOptions): UnaryCall<BulkGenerateGiftCardNumbersReq, BulkGenerateGiftCardNumbersRes>;
    /**
     * @generated from protobuf rpc: BulkImportGiftCardNumbers
     */
    bulkImportGiftCardNumbers(input: BulkImportGiftCardNumbersReq, options?: RpcOptions): UnaryCall<BulkImportGiftCardNumbersReq, BulkImportGiftCardNumbersRes>;
    /**
     * @generated from protobuf rpc: DeactivateGiftCard
     */
    deactivateGiftCard(input: DeactivateGiftCardReq, options?: RpcOptions): UnaryCall<DeactivateGiftCardReq, DeactivateGiftCardRes>;
    /**
     * @generated from protobuf rpc: GetGiftCardHistoryPDF
     */
    getGiftCardHistoryPDF(input: GetGiftCardHistoryPDFReq, options?: RpcOptions): UnaryCall<GetGiftCardHistoryPDFReq, GetGiftCardHistoryPDFRes>;
    /**
     * @generated from protobuf rpc: SellGiftCardAtDifferentPrice
     */
    sellGiftCardAtDifferentPrice(input: SellGiftCardAtDifferentPriceReq, options?: RpcOptions): UnaryCall<SellGiftCardAtDifferentPriceReq, SellGiftCardAtDifferentPriceRes>;
    /**
     * @generated from protobuf rpc: EnableOrDisableGiftCards
     */
    enableOrDisableGiftCards(input: EnableOrDisableGiftCardsReq, options?: RpcOptions): UnaryCall<EnableOrDisableGiftCardsReq, EnableOrDisableGiftCardsRes>;
}
/**
 * @generated from protobuf service rd.api.giftcard.GiftCardService
 */
export class GiftCardServiceClient implements IGiftCardServiceClient, ServiceInfo {
    typeName = GiftCardService.typeName;
    methods = GiftCardService.methods;
    options = GiftCardService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetGiftCard
     */
    getGiftCard(input: GetGiftCardReq, options?: RpcOptions): UnaryCall<GetGiftCardReq, GetGiftCardRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetGiftCardReq, GetGiftCardRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetGiftCardByNumber
     */
    getGiftCardByNumber(input: GetGiftCardByNumberReq, options?: RpcOptions): UnaryCall<GetGiftCardByNumberReq, GetGiftCardByNumberRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetGiftCardByNumberReq, GetGiftCardByNumberRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListGiftCardHistory
     */
    listGiftCardHistory(input: ListGiftCardHistoryReq, options?: RpcOptions): UnaryCall<ListGiftCardHistoryReq, ListGiftCardHistoryRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListGiftCardHistoryReq, ListGiftCardHistoryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkGenerateGiftCardNumbers
     */
    bulkGenerateGiftCardNumbers(input: BulkGenerateGiftCardNumbersReq, options?: RpcOptions): UnaryCall<BulkGenerateGiftCardNumbersReq, BulkGenerateGiftCardNumbersRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkGenerateGiftCardNumbersReq, BulkGenerateGiftCardNumbersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkImportGiftCardNumbers
     */
    bulkImportGiftCardNumbers(input: BulkImportGiftCardNumbersReq, options?: RpcOptions): UnaryCall<BulkImportGiftCardNumbersReq, BulkImportGiftCardNumbersRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkImportGiftCardNumbersReq, BulkImportGiftCardNumbersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateGiftCard
     */
    deactivateGiftCard(input: DeactivateGiftCardReq, options?: RpcOptions): UnaryCall<DeactivateGiftCardReq, DeactivateGiftCardRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateGiftCardReq, DeactivateGiftCardRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetGiftCardHistoryPDF
     */
    getGiftCardHistoryPDF(input: GetGiftCardHistoryPDFReq, options?: RpcOptions): UnaryCall<GetGiftCardHistoryPDFReq, GetGiftCardHistoryPDFRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetGiftCardHistoryPDFReq, GetGiftCardHistoryPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SellGiftCardAtDifferentPrice
     */
    sellGiftCardAtDifferentPrice(input: SellGiftCardAtDifferentPriceReq, options?: RpcOptions): UnaryCall<SellGiftCardAtDifferentPriceReq, SellGiftCardAtDifferentPriceRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<SellGiftCardAtDifferentPriceReq, SellGiftCardAtDifferentPriceRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EnableOrDisableGiftCards
     */
    enableOrDisableGiftCards(input: EnableOrDisableGiftCardsReq, options?: RpcOptions): UnaryCall<EnableOrDisableGiftCardsReq, EnableOrDisableGiftCardsRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<EnableOrDisableGiftCardsReq, EnableOrDisableGiftCardsRes>("unary", this._transport, method, opt, input);
    }
}
